import React from "react";

const Footer = () => (
  <section className="footer  bg-dark text-white">
    <p className="lead container">Contact us at Instagram</p>
    <p className="lead container">You can react via email too</p>
    <p className="lead container">NO COPYRIGHT</p>
  </section>
);

export default Footer;
